module.exports = __webpack_public_path__ + "img/banner_bg_2.4e2c6b98.jpg";